import { render, staticRenderFns } from "./SaleInside.vue?vue&type=template&id=4a052c67&"
import script from "./SaleInside.vue?vue&type=script&lang=js&"
export * from "./SaleInside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports